import { render, staticRenderFns } from "./ShapeHeadBottom.vue?vue&type=template&id=5a6516a9&scoped=true&"
var script = {}
import style0 from "./ShapeHeadBottom.vue?vue&type=style&index=0&id=5a6516a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6516a9",
  null
  
)

export default component.exports